export function useIsVatExempt() {
	const { currentTerminal } = useCurrentTerminal();
	const isVatExempt = computed<boolean>(() => currentTerminal.value?.metadata?.isVatExempt);
	return { isVatExempt };
}
